import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form/immutable';
import PropTypes from 'prop-types';

import './auth.css';
import misc from '../../misc';

export class ResetPassword extends Component {
  render() {
    const { error, handleSubmit, pristine, submitting } = this.props;

    return (
      <div className="container">
        <div className="row justify-content-md-center">
          <div className="col-md-6">
            <form onSubmit={handleSubmit(this.props.onSubmit)}>
              <div className="text-center m-4">
                <img
                  src={misc.images.logoGrey3}
                  width="30"
                  height="30"
                  className="d-inline-block align-top"
                  alt="Federation"
                />
                <h2 className="mb-1 d-inline-block align-bottom">
                  &nbsp;Reset Password
                </h2>
              </div>

              {error && <misc.components.Alert message={error} />}

              <Field
                component={misc.components.FormField}
                name="password"
                id="password"
                type="password"
                label="New password"
                required
              />
              <Field
                component={misc.components.FormField}
                name="passwordConfirm"
                id="passwordConfirm"
                type="password"
                label="Confirm password"
                required
              />
              <misc.components.LoadingButton
                className="btn-lg"
                disabled={pristine || submitting}
                loading={this.props.isLoading}
              >
                Confirm
              </misc.components.LoadingButton>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

ResetPassword.propTypes = {
  errorMessage: PropTypes.string,
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired
};

ResetPassword.defaultProps = {
  isLoading: false,
  isError: false,
  errorMessage: 'Sorry, an error occurred.'
};

export function validate(values) {
  const errors = {};

  // Password
  if (!values.get('password')) {
    errors.password = true;
  } else if (!misc.lib.validators.validatePassword(values.get('password'))) {
    errors.password =
      'Password must have a minimum of 8 characters including uppercase, lowercase, and digits';
  }

  // Password confirmation
  if (!values.get('passwordConfirm')) {
    errors.passwordConfirm = true;
  } else if (values.get('password') !== values.get('passwordConfirm')) {
    errors.passwordConfirm = 'Passwords do not match';
  }

  return errors;
}

export default reduxForm({
  validate,
  form: 'resetPasswordForm'
})(ResetPassword);



// WEBPACK FOOTER //
// ./src/modules/auth/components/ResetPassword.js